import { useQuery } from '@tanstack/react-query';
import { menuApi } from '../api/menuApi';

/**
 * GET /api/eraf/menus — 전체 메뉴 트리 (관리자용)
 * queryKey: ['menu-management', 'tree']
 */
export function useMenuTree() {
  return useQuery({
    queryKey: ['menu-management', 'tree'],
    queryFn: () => menuApi.getTree(),
    staleTime: 30_000,
  });
}
